import { render, staticRenderFns } from "./search-keywords.vue?vue&type=template&id=28170ba1&scoped=true&"
import script from "./search-keywords.vue?vue&type=script&lang=js&"
export * from "./search-keywords.vue?vue&type=script&lang=js&"
import style0 from "./search-keywords.vue?vue&type=style&index=0&id=28170ba1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28170ba1",
  null
  
)

export default component.exports